<template>
  <section class="exchange-btn-wrapper">
    <common-btn
      :class="['exchange-btn']"
      @click="toExchange"
      :btnText="btnText"
      :tipsLeft="tipsLeft"
      :tipsText="tipsText"
      :animation="animation"
      :type="type"
      :hasTips="hasTips"
    />
  </section>
</template>
<script>
  import CommonBtn from './index.vue'

  export default {
    props: {
      // 按钮文案
      btnText: {
        type: String,
        default: '',
      },
      // 按钮“呼吸”动画
      animation: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
      // 是否有按钮tips提示
      hasTips: {
        type: Boolean,
        default: true,
      },
      // tips提示文案
      tipsText: {
        type: String,
        default: '',
      },
      // tips提示left位置
      tipsLeft: {
        type: String,
        default: '50%',
      },
    },
    components: {
      CommonBtn,
    },
    methods: {
      toExchange() {
        this.$emit('click')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .exchange-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
